<app-new-student *ngIf="showNewStudentDialog" [parentGuardianDetails]="parentGuardianDetails"
  [showDialog]="showNewStudentDialog" [student]="currentStudent" [type]="type"
  (hideDialog)="showNewStudentDialog = false"></app-new-student>

<kendo-dialog title="Student Search" *ngIf="showSearchModal" (close)="onHideHandler()" maxHeight="85vh" width="80vw"
  [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }">

  <div class="search-instructions" [ngClass]="{ 'form-error': emptySearchMsg  }" *ngIf="!showCreateLinkStudent">
    Please enter either a valid Student ID or the Student Name to proceed.
  </div>

  <div class="search-instructions" [ngClass]="{ 'form-error': emptyStudentLink }" *ngIf="showCreateLinkStudent">
    Please enter valid Student Name to proceed.
  </div>

  <form [formGroup]="searchFormGroup">
    <div class="search-form">
      <kendo-formfield class="flex-element" *ngIf="!showCreateLinkStudent">
        <kendo-floatinglabel text="Student ID">
          <kendo-numerictextbox format="##" #nycid size="large" [maxlength]="9" rounded="large" formControlName="nycid"
            [spinners]="false">
          </kendo-numerictextbox>
        </kendo-floatinglabel>
        <kendo-formhint>Student ID should be 6, 7 or 9 digits</kendo-formhint>
        <kendo-formerror *ngIf="searchFormGroup.get('nycid').errors?.invalidNycid">
          Student ID should be 6, 7 or 9 digits
        </kendo-formerror>
      </kendo-formfield>
      <div *ngIf="!showCreateLinkStudent" class="flex-element no-grow or-icon">&nbsp;</div>
      <kendo-formfield [ngClass]="showCreateLinkStudent === true ?   'student-link-flex-element'  : 'flex-element'">
        <kendo-floatinglabel text="First Name">
          <kendo-textbox #firstName size="large" (keypress)="restrictNumbers($event)" rounded="large"
            formControlName="firstName">
          </kendo-textbox>
        </kendo-floatinglabel>
        <kendo-formerror>
          {{ searchFormGroup.get('firstName')?.errors?.validateName?.message }}
        </kendo-formerror>
      </kendo-formfield>

      <kendo-formfield class="flex-element">
        <kendo-floatinglabel text="Last Name">
          <kendo-textbox #lastName size="large" rounded="large" (keypress)="restrictNumbers($event)"
            formControlName="lastName">
          </kendo-textbox>
        </kendo-floatinglabel>
        <kendo-formerror>
          {{ searchFormGroup.get('lastName')?.errors?.validateName?.message }}
        </kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="showCreateLinkStudent">
        <kendo-floatinglabel text="DOB">
          <kendo-datepicker calendarType="classic" #dob formControlName="dob" rounded="large" [size]="'large'"
            [formatPlaceholder]="formatPlaceholder" [min]="minDOB" [max]="maxDOB">
          </kendo-datepicker>
        </kendo-floatinglabel>
        <kendo-formerror *ngIf="searchFormGroup.get('dob')?.hasError('required')">
          Date of Birth is required.
        </kendo-formerror>

      </kendo-formfield>

      <button kendoButton class="search-btn" themeColor="primary" type="button" rounded="large" fillMode="solid"
        (click)="studentSearch()"
        [disabled]="searchFormGroup.get('firstName')?.invalid || searchFormGroup.get('lastName')?.invalid || searchFormGroup.get('nycid')?.invalid || searchFormGroup.get('dob')?.invalid">
        Search
      </button>
    </div>
  </form>

  <div [hidden]="!showResults" aria-live="assertive">
    <p>
      Please review the following students from the general education and special education database and select the
      name that matches
      the student being referred.
    </p>

    <div class="loading-container" *ngIf="loadCreateLinkStudentSpinner">
      <kendo-loader type="converging-spinner" size="medium"></kendo-loader>
    </div>

    <kendo-grid #grid class="student-search-grid" [kendoGridBinding]="students" scrollable="none" [pageSize]="pageSize"
      [pageable]="true" [sortable]="true" [groupable]="false" [resizable]="false"
      [columnMenu]="{ filter: true, columnChooser: false }" [loading]="loading" [selectable]="false">

      <kendo-grid-column #grid field="" [sortable]="false" [width]="40" headerClass="action-column" title="Actions">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

          <div kendoToolTip [title]="!dataItem.isPreSchool ? 'There are no actions available for this student.' : '' "
            showOn="hover">
            <button kendoButton #anchor [svgIcon]="actionIcon" fillMode="clear" size="none"
              (click)="openMenu(dataItem, rowIndex)"
              [disabled]="!dataItem?.isPreSchool && !dataItem?.isSpecialEd"></button>
          </div>

        </ng-template>

      </kendo-grid-column>

      <kendo-grid-column field="studentName" title="Student" [width]="350">
        <ng-template kendoGridCellTemplate let-data>
          <div class="name-container">
            <div class="student-name k-text-ellipsis">{{ data.studentName }}</div>

          </div>
          <div class="student-id">{{ data.nycId ? data.nycId : data.eiId ? 'EI: ' + data.eiId : ''}}</div>
          <div class="name-container">
            <kendo-chip *ngIf="data.atsStatus === dischargedStatusCode || data.atsStatus === discharged" rounded="full"
              size="large" fillMode="solid" themeColor="warning" class="status-chip closed-chip" [selected]="true"
              label="ATS: Discharged">
            </kendo-chip>
            <kendo-chip *ngIf="data.atsStatus === activeStatusCode || data.atsStatus === active" rounded="full"
              size="large" fillMode="outline" themeColor="info" class="status-chip" [selected]="true"
              label="ATS: Active">
            </kendo-chip>
            <!-- Added for demo -->
            <kendo-chip *ngIf="data.isActive" rounded="full" size="large" fillMode="solid" themeColor="success"
              class="status-chip active-chip" [selected]="true" label="Special Education Status: Active">
            </kendo-chip>
            <kendo-chip *ngIf="data.isActive === false || data.studentStatus === closed" rounded="full" size="large"
              fillMode="solid" themeColor="none" class="status-chip closed-chip gray-chip" [selected]="true">

              <ng-container *ngIf="data.caseCloseDate">
                {{ data.isActive === false ? 'Special Education Status: Inactive (' + (data.caseCloseDate | date:
                'MM/dd/yyyy') + ')' :
                data.studentStatus === 'Closed' ? 'Special Education Status: Case Closed (' + (data.caseCloseDate |
                date:
                'MM/dd/yyyy') + ')' : '' }}
              </ng-container>

            </kendo-chip>

            <kendo-chip *ngIf="data.ineligibleSE" rounded="full" size="large" fillMode="solid" themeColor="warning"
              class="status-chip active-chip" [selected]="true" label="Special Education Status: Ineligible">
            </kendo-chip>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="dateOfBirthUnixTimestamp" title="DOB" [width]="100" [resizable]="false">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{dataItem.dateOfBirth}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="gender" title="Gender" [width]="100" [resizable]="false"></kendo-grid-column>
      <kendo-grid-column field="grade" title="Grade" [width]="90" [resizable]="false"></kendo-grid-column>
      <kendo-grid-column field="school" title="School" [width]="200"></kendo-grid-column>

      <ng-template kendoGridNoRecordsTemplate>
        <p>There is no data to display.</p>
      </ng-template>

      <ng-template kendoGridLoadingTemplate>
        <!-- TODO: this will need to be placed in its own component: a custom ATLAS loader component -->
        <!-- TODO: once the code below is in its own component we'll need to add `[hidden]=true` to: <div class="k-loading-panel">  -->
        <div class="k-loading-panel">
          <div class="k-loading-panel-mask"></div>
          <div class="k-loading-panel-wrapper">
            <kendo-loader type="converging-spinner" size="medium"></kendo-loader>
            <!-- TODO: do we also want to add the "Loading..." text? -->
          </div>
        </div>
      </ng-template>
    </kendo-grid>
    <kendo-contextmenu #gridmenu showOn="click" [items]="dataItem?.actions"
      (select)="onSelect($event)"></kendo-contextmenu>

  </div>
  <kendo-dialog-actions layout="end" *ngIf="showCreateStudentBtn">

    <button kendoButton themeColor="primary" type="button" rounded="large" fillMode="solid" [svgIcon]="svgPlus"
      *ngIf="showCreate" (click)="addNewStudent(false)">Create New Student</button>
  </kendo-dialog-actions>
</kendo-dialog>